import {
    ResourceAllocationState,
    Tag,
    ProjectTag,
    PersonTag,
    AssignmentTag,
    TeamTag
} from '../../../types';
import {removeTagCascade} from '../cascadeDelete';

export const tagHandlers = {
    TagAdded: (
        state: ResourceAllocationState,
        data: Tag
    ): ResourceAllocationState => {
        if (!data.id) return state;
        return {
            ...state,
            tags: {...state.tags, [data.id]: data}
        };
    },
    TagUpdated: (
        state: ResourceAllocationState,
        data: {id: string; updates: Partial<Tag>}
    ): ResourceAllocationState => {
        return {
            ...state,
            tags: {
                ...state.tags,
                [data.id]: {
                    ...state.tags[data.id],
                    ...data.updates
                }
            }
        };
    },
    TagDeleted: (
        state: ResourceAllocationState,
        data: {id: string}
    ): ResourceAllocationState => {
        // Mirror the DB cascade: also prune project-tag associations for this tag.
        return removeTagCascade(state, data.id);
    },

    // ================== PROJECT TAG EVENTS ==================
    ProjectTagAdded: (
        state: ResourceAllocationState,
        data: ProjectTag
    ): ResourceAllocationState => {
        return {
            ...state,
            projectTags: {...state.projectTags, [data.id]: data}
        };
    },
    ProjectTagDeleted: (
        state: ResourceAllocationState,
        data: {id: string}
    ): ResourceAllocationState => {
        const {[data.id]: _removed, ...rest} = state.projectTags;
        return {...state, projectTags: rest};
    },

    // ================== PERSON TAG EVENTS ==================
    PersonTagAdded: (
        state: ResourceAllocationState,
        data: PersonTag
    ): ResourceAllocationState => {
        return {
            ...state,
            personTags: {...state.personTags, [data.id]: data}
        };
    },
    PersonTagDeleted: (
        state: ResourceAllocationState,
        data: {id: string}
    ): ResourceAllocationState => {
        const {[data.id]: _removed, ...rest} = state.personTags;
        return {...state, personTags: rest};
    },

    // ================== ASSIGNMENT TAG EVENTS ==================
    AssignmentTagAdded: (
        state: ResourceAllocationState,
        data: AssignmentTag
    ): ResourceAllocationState => {
        return {
            ...state,
            assignmentTags: {...state.assignmentTags, [data.id]: data}
        };
    },
    // Level (Must/Should/Could) changed — the association itself is immutable.
    AssignmentTagUpdated: (
        state: ResourceAllocationState,
        data: AssignmentTag
    ): ResourceAllocationState => {
        if (!state.assignmentTags[data.id]) return state;
        return {
            ...state,
            assignmentTags: {...state.assignmentTags, [data.id]: data}
        };
    },
    AssignmentTagDeleted: (
        state: ResourceAllocationState,
        data: {id: string}
    ): ResourceAllocationState => {
        const {[data.id]: _removed, ...rest} = state.assignmentTags;
        return {...state, assignmentTags: rest};
    },

    // ================== TEAM TAG EVENTS ==================
    TeamTagAdded: (
        state: ResourceAllocationState,
        data: TeamTag
    ): ResourceAllocationState => {
        return {
            ...state,
            teamTags: {...state.teamTags, [data.id]: data}
        };
    },
    TeamTagDeleted: (
        state: ResourceAllocationState,
        data: {id: string}
    ): ResourceAllocationState => {
        const {[data.id]: _removed, ...rest} = state.teamTags;
        return {...state, teamTags: rest};
    }
};
